import { useState, useEffect } from "react";

const useInterval = (callback, delay) => {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setTick((prevTick) => prevTick + 1);
      callback();
    }, delay);

    return () => clearInterval(id);
  }, [delay, callback]);

  return tick;
};

export default useInterval;
